export class CacheNode {
	constructor(key, value) {
		this.key = key;
		this.value = value;
		this.next = null;
		this.prev = null;
	}
}

export class LruCache {

	constructor(limit = 100) {
		this.map = {};
		this.head = null;
		this.tail = null;
		this.limit = limit || 100;
		this.size = 0;
	}

	get(key) {
		if (this.map[key]) {
			let value = this.map[key].value;
			let node = new CacheNode(key, value);
			this.remove(key);
			this.setHead(node);
			return value;
		}
	}

	set(key, value) {
		let node = new CacheNode(key, value);
		if (this.map[key]) {
			this.remove(key);
		} else {
			if (this.size >= this.limit) {
				delete this.map[this.tail.key];
				this.size--;
				this.tail = this.tail.prev;
				this.tail.next = null;
			}
		}
		this.setHead(node);
	}

	setHead(node) {
		node.next = this.head;
		node.prev = null;
		if (this.head) {
			this.head.prev = node;
		}
		this.head = node;
		if (!this.tail) {
			this.tail = node;
		}
		this.size++;
		this.map[node.key] = node;
	}

	remove(key) {
		let node = this.map[key];
		if (node.prev) {
			node.prev.next = node.next;
		} else {
			this.head = node.next;
		}
		if (node.next) {
			node.next.prev = node.prev;
		} else {
			this.tail = node.prev;
		}
		delete this.map[key];
		this.size--;
	}
}